// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "cart-3C4HH";
export { _1 as "__esModule", _2 as "tablet", _3 as "cart" }
export default { "__esModule": _1, "tablet": _2, "cart": _3 }
